export const getPendingWebsocketAction = (type, response) => ({
  type,
  websocketUrl: response?.websocket_url,
})
